import { render, staticRenderFns } from "./mAbout.vue?vue&type=template&id=271102f5&scoped=true"
import script from "./mAbout.vue?vue&type=script&lang=js"
export * from "./mAbout.vue?vue&type=script&lang=js"
import style0 from "./mAbout.vue?vue&type=style&index=0&id=271102f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271102f5",
  null
  
)

export default component.exports